import one from '../assets/svg/projects/liberty.svg'
import two from '../assets/svg/projects/cinema.svg'
import three from '../assets/svg/projects/labyrinth.svg'
import four from '../assets/svg/projects/motorway.svg'
import five from '../assets/svg/projects/board.svg'
import six from '../assets/svg/projects/robotic-hand.svg'


export const projectsData = [
        {
        id: 1,
        projectName: 'Gender Inequalities in Cinema Website',
        projectDesc: 'Gender inequalities in the film industry: Data analysis and visualization (NOT visible on mobiles)',
        tags: ['Data Analysis', 'Data Visualisation', 'Web Developpement'],
        code: 'https://github.com/elsahtz2/Women_in_cinema-DataAnalysis?tab=readme-ov-file',
        demo: 'https://elsahtz2.github.io/Women_in_cinema-DataAnalysis/',
        image: two
    },
    {
        id: 2,
        projectName: 'NYC Crime Analysis Website',
        projectDesc: 'Interactive web page that visualizes the correlation between crime rates and socio-economic factors in New York City. (NOT visible on mobiles)',
        tags: ['Data Analysis', 'Data Visualisation', 'Web Developpement'],
        code: 'https://github.com/com-480-data-visualization/BluePink?tab=readme-ov-file',
        demo: 'https://com-480-data-visualization.github.io/BluePink/index.html',
        image: one
    },

    {
        id: 3,
        projectName: 'Robot Maze Navigation',
        projectDesc: 'Autonomous robot programming to navigate through a maze using computer vision, global path planning, Bayesian filtering, and local obstacle avoidance.',
        tags: ['Global & Local Nav.', 'Computer Vision', 'Path Planning'],
        code: 'https://github.com/elsahtz2/Robot_Maze_Navigation',
        demo: 'https://github.com/elsahtz2/Robot_Maze_Navigation',
        image: three
    },
    {
        id: 4,
        projectName: 'Road Segmentation',
        projectDesc: 'Optimizing a deep learning model (CNN) for road segmentation in aerial imagery using U-Net, SegNet and LinkNet.',
        tags: ['Neural Networks', 'CNN', 'Image Processing'],
        code: 'https://github.com/elsahtz2/Road-Segmentation-in-Aerial-Imagery',
        demo: 'https://github.com/elsahtz2/Road-Segmentation-in-Aerial-Imagery/blob/main/Report.pdf',
        image: four
    },
    {
        id: 5,
        projectName: 'Connect 4 on Microcontroller',
        projectDesc: 'A Simple Connect 4 game implemented on a microcontroller.',
        tags: ['Embedded Systems'],
        code: 'https://github.com/elsahtz2/Microcontroller_Connect4',
        demo: 'https://www.youtube.com/shorts/qVmoHr3td7o',
        image: five
    },
    {
        id: 6,
        projectName: 'Robotic Hand Prosthesis',
        projectDesc: 'Integration of a Kinematic Glove for EMG Decoder Calibration and Optimizing Preprocessing for Real-Time Robotic Hand Control.',
        tags: ['Robotics', 'EMG Signal Processing', 'Machine Learning'],
        code: 'https://github.com/elsahtz2/Project-PDF/blob/main/Hand_prothesis_PDS.pdf',
        demo: 'https://github.com/elsahtz2/Project-PDF/blob/main/Hand_prothesis_PDS.pdf',
        image: six
    }
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/